import {TimelineLite} from "gsap";

export const timelineContainer = <Base extends new(...args: any[]) => PIXI.Container>(base: Base) =>
    class TimelineTarget extends base {

        private readonly _timelines: TimelineLite[] = [];

        public newTimeline(): TimelineLite {
            const timeline = new TimelineLite();
            for (let i = 0; i < this._timelines.length; i++) {
                if (this._timelines[i].totalProgress() >= 1) {
                    this._timelines.splice(i, 1);
                    i--;
                }
            }
            this._timelines.push(timeline);
            return timeline;
        }

        public killTimelines() {
            while (this._timelines.length > 0) {
                this._timelines.pop()!.kill();
            }
        }

        public destroy(options?: PIXI.DestroyOptions | boolean) {
            this.killTimelines();
            super.destroy(options);
        }
    };
